import React, { Component } from "react";
import { connect } from "react-redux";

import { addModal } from "../store/app";
import { getLendingRequests, postClientDetails } from "../store/request";

import lendingTypes from "../config/lendingTypes";

import Button from "../components/Button";
import DismissLendingModal from "../containers/DismissLendingModal";
import Icon from "../components/Icons";
import LendingRequestsStatusFilters from "../components/LendingRequestsStatusFilters";
import { LendingRequestsList } from "../components/LendingRequestsList";
import PageHeader from "../components/PageHeader";
import t from "babel-plugin-yate/macro";

class LendingRequests extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.searchRef = React.createRef();
  }

  getInitialState = () => {
    const { lendingType, startDate, endDate } = this.props;

    this.lendingType = lendingTypes[lendingType];

    return {
      isLoadingRequests: true,
      requests: [],
      pagination: {
        items: 0,
        pages: 0,
        currentPage: 0,
      },
      filters: {
        startDate,
        endDate,
        status: "all",
        search: "",
        page: 1,
        itemsPerPage: 30,
      },
    };
  };

  formatRequestDate = (dat) => {
    const date = new Date(dat);
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  };

  getLendingRequests = () => {
    this.setState(
      {
        isLoadingRequests: true,
        requests: [],
        pagination: {
          items: 0,
          pages: 0,
          currentPage: 0,
        },
      },
      async () => {
        const {
          getLendingRequests,
          locationId,
          accessType,
          startDate,
          endDate,
        } = this.props;
        const { status, search, page, itemsPerPage } = this.state.filters;

        const requestFilters = {
          // apply the filter "view=broker_agent" only if the accessType is also "broker_agent"
          ...(accessType?.includes("broker_agent") && { view: "broker_agent" }),
          items_per_page: itemsPerPage,
        };

        // Set page number
        if (page !== 1) {
          requestFilters.page_no = page;
        }

        // Set dates filters
        if (startDate && endDate) {
          requestFilters.from_date = this.formatRequestDate(startDate);
          requestFilters.to_date = this.formatRequestDate(endDate);
        }

        // Set status filter
        if (status !== "all") {
          requestFilters.status = status;
        }

        // Set search filter
        if (search) {
          requestFilters.search = encodeURIComponent(search);
        }

        // Set location filter
        if (locationId !== "0") {
          requestFilters.location_id = locationId;
        }

        const req = await getLendingRequests({
          ...requestFilters,
          ...(!search && { type: this.lendingType.type }),
        });

        if (req && !req.error) {
          this.setState({
            requests: req.credit_request_dtos,
            pagination: {
              items: req.metadata.total_items,
              pages: req.metadata.total_pages,
              currentPage: req.metadata.current_page,
            },
          });
        }

        this.setState({ isLoadingRequests: false });
      },
    );
  };

  handleFilterChange = async ({ status, page } = {}) => {
    this.setState(
      (state) => ({
        filters: {
          ...state.filters,
          ...(status ? { status } : {}),
          ...(page ? { page } : {}),
          search: this.searchRef.value,
        },
      }),
      this.getLendingRequests,
    );
  };

  handleUserAssign = async (username, requestId) => {
    const { postClientDetails } = this.props;
    const { requests } = this.state;

    const response = await postClientDetails(
      {
        assigned_to: username,
      },
      requestId,
    );

    if (!response.error) {
      const updatedRequests = requests.map((request) =>
        request.id === requestId
          ? { ...request, assigned_to: response.assigned_to }
          : request,
      );

      this.setState({
        requests: updatedRequests,
      });
    }
  };

  cancelApplicationById = (requestId) => {
    const {
      props: { addModal },
    } = this;

    this.setState(
      {
        idCanceledApplication: requestId,
      },
      () => addModal("cancelLendingRequest"),
    );
  };

  async componentDidMount() {
    this.handleFilterChange();
  }

  componentDidUpdate(prevProps) {
    const { locationId, lendingType, startDate, endDate } = this.props;

    if (
      startDate !== prevProps.startDate ||
      endDate !== prevProps.endDate ||
      locationId !== prevProps.locationId
    ) {
      this.handleFilterChange();
    }

    if (lendingTypes[lendingType] !== lendingTypes[prevProps.lendingType]) {
      this.setState(this.getInitialState(), this.handleFilterChange);
    }
  }

  render() {
    const { accessType, currentUsername } = this.props;
    const {
      requests,
      idCanceledApplication,
      isLoadingRequests,
      filters,
      pagination,
    } = this.state;

    return (
      <>
        <PageHeader
          title={this.lendingType.name}
          actions={
            <div className="flex">
              <div className="flex mr-5">
                <div className="flex flex-col mr-1">
                  <input
                    type="search"
                    ref={(el) => {
                      this.searchRef = el;
                      (el || {}).onsearch = this.handleFilterChange;
                    }}
                    className="appearance-none border rounded w-full py-2 px-4 text-grey-darker text-14 border-grey"
                    placeholder={t`Search by CNP, application ID, customer name or contract number`}
                    style={{ width: 470 }}
                  />
                </div>

                <Button
                  icon={true}
                  customProps={{
                    type: "button",
                    style: {
                      alignSelf: "flex-start",
                    },
                  }}
                  onClick={this.handleFilterChange}
                  iconSrc={<Icon name="Search" />}
                  color="white"
                  border={true}
                />
              </div>
            </div>
          }
          lendingType={this.lendingType}
          accessType={accessType}
        />

        <div className="mb-8">
          <LendingRequestsStatusFilters
            statusFilter={filters.status}
            onFilterChange={this.handleFilterChange}
          />

          <LendingRequestsList
            handleCancelApplication={this.cancelApplicationById}
            lendingType={this.lendingType}
            requests={requests}
            accessType={accessType}
            currentUsername={currentUsername}
            onUserAssign={this.handleUserAssign}
            isLoading={isLoadingRequests}
            pagination={pagination}
            onPageChange={(value) => this.handleFilterChange({ page: value })}
          />

          {idCanceledApplication && (
            <DismissLendingModal
              type="cancel"
              requestId={idCanceledApplication}
            />
          )}
        </div>
      </>
    );
  }
}

export default connect(
  (state) => ({
    locationId: state.auth.locationId,
    accessType: state.auth.user.access_type,
    currentUsername: state.auth.user.username,
    startDate: state.app.dateFilter.startDate,
    endDate: state.app.dateFilter.endDate,
  }),
  {
    addModal,
    getLendingRequests,
    postClientDetails,
  },
)(LendingRequests);
